import React from 'react';
import { Box, useWidth } from 'vindi-ds-components';
import styles from './styles';
import mobileStyles from './mobile/styles';

function Actions({ children }) {
  const breakpoint = useWidth();
  let stylesCss = styles;

  if (['xs', 'sm'].includes(breakpoint)) {
    stylesCss = mobileStyles;
  }

  return (
    <Box css={stylesCss.actions}>{children}</Box>
  );
}

export default Actions;
